export default __webpack_public_path__ + "static/media/carouselImage1.1b0fc239.jpg";